import {LexicalEditor} from "lexical"
import {
    INSERT_CHECK_LIST_COMMAND,
    INSERT_ORDERED_LIST_COMMAND,
    INSERT_UNORDERED_LIST_COMMAND,
    REMOVE_LIST_COMMAND
} from "@lexical/list";

type Lists = 'check' | 'bullet' | 'number'

const debug = false
// const debug = "lexicalChangeList"

export function lexicalChangeList(editor: LexicalEditor, currentBockType: Lists, value: Lists) {
    switch (value) {
        case 'check'    :
            if (currentBockType !== 'check') {
                editor.dispatchCommand(INSERT_CHECK_LIST_COMMAND, undefined)
            } else {
                editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined)
            }
            break

        case 'bullet'   :
            if (currentBockType !== 'bullet') {
                editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined)
            } else {
                editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined)
            }
            break

        case 'number'   :
            if (currentBockType !== 'number') {
                editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined)
            } else {
                editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined)
            }
            break
    }
}